import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import {Button, ButtonGroup, Progress} from "reactstrap";
import ChevronLeftIcon from "../../../media/images/ChevronLeftIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import SkipToPreviousIcon from "../../../media/images/SkipToPreviousIcon.mjs";
import MySelect from "../../../controls/MySelect/MySelect.mjs";
import SkipToNextIcon from "../../../media/images/SkipToNextIcon.mjs";
import appLib from "../../../libs/appLib.mjs";
import ListIcon from "../../../media/images/ListIcon.mjs";
import FullScreenModal from "../../../controls/FullScreen/FullScreenModal.mjs";
import AppSynthDataIcon from "../../../media/app-images/AppSynthDataIcon.mjs";
import AppPerimeterIcon from "../../../media/app-images/AppPerimeterIcon.mjs";
import AppPalleIcon from "../../../media/app-images/AppPalleIcon.mjs";
import "./SimulationFlowOver.css";
import AppDownloadIcon from "../../../media/app-images/AppDownloadIcon.mjs";
import ChevronRightIcon from "../../../media/images/ChevronRightIcon.mjs";
import PeriGraphic from "../../../ComponentParts/Perimeters/PeriGraphic.mjs";
import PeriGantt from "../../../ComponentParts/Simulations/PeriGantt.mjs";

const prefix = "SimulationFlowOver";

/**
 * @typedef stepData
 * @type {FallingByStep|boolean}
 * @private
 */

/**
 * @typedef FallingByStep
 * @type {Object}
 * @private
 * @property {Array<FallingItemByStep>} items
 */

/**
 * @typedef FallingItemByStep
 * @type {Object}
 * @private
 * @property {boolean} [fallen]
 * @property {boolean} [falling]
 * @property {string} [by]
 * @property {number} [delay]
 * @property {Record<"c"|"i"|"a"|"o",number>} status
 * @property {Object} [data]
 * @property {string} [data.type]
 * @property {string} [data.name]
 * @property {string} [data.subject]
 * @property {string} [data.subjectName]
 */


const SimulationFlowOver = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			/** @type {stepData} */
			stepData: false,
			ll: Glob.getLanguageLong(),
			tableSort: { field: "name"}
		}
		this.uid = Glob.generateUid(prefix);
		this.loadStep = this.loadStep.bind(this);
		this.loadStepIndex = this.loadStepIndex.bind(this);
		this.tableSort = this.tableSort.bind(this);
		this.sortBy = this.sortBy.bind(this);
	}
	componentDidMount() {
		appLib.strategicItems().then( this.loadStepIndex );
	}
	loadStepIndex() {
		appLib.api("simul/steps-macro", { simID: this.props.simul.id }).then( stepsDoc => {
			const steps = stepsDoc?.steps || [];
			const options = steps.map( (sd, idx) => {
				const s = { label: sd?.label, value : 'step-' + idx };
				if ( sd?.model ) s[sd.model] = true;
				if ( sd.curTime ) s.label += ' - '+this.showDelay(sd.curTime);
				return s;
			});
			this.setState({
				firstStep: options[0].value,
				currentStep: options[0].value,
				lastStep: options[ options.length -1 ].value,
				stepOptions: options,
				allStepsData: steps,
				allItemsData: stepsDoc.data || {},
			}, this.loadStep );
		});
	}
	loadStep() {
		return new Promise( resolve => {
			if ( ! this.state.currentStep ) return resolve();
			this.setState({ stepData: false, stepLoading: true }, async ()=>{
				const ns = { delay: false };
				if ( ! this.state.triggers ) {
					ns.triggers = Object.keys(this.state.allStepsData[0]?.items||{});
				}
				const all = ns.stedData = structuredClone(this.state.allStepsData[ parseInt(this.state.currentStep.split('-').pop()) ]);
				if ( all.delay || all.curTime ) ns.delay = all.delay || all.curTime;
				const s = {};
				s.model = ns.model = all.model;
				s.delay = all.delay || all.curTime || 0;
				s.elapsed = all.elapsed || 0;
				s.label = all.label;
				s.history = all.history;
				const bys = [];
				Object.entries(all.items).forEach( ([id,x]) => {
					s[id] = x.status;
					x.fresh = true;
					if ( x.falling ) {
						if ( x.delay > s.delay ) s.delay = x.delay;
						bys.push( { source: id, target: x.by } );
					}
				});
				s.stepFall = Object.keys(all.items).length;
				Object.entries( all.current ).forEach( ([id, x]) => {
					if ( ! x.falling ) return;
					if ( all.items[ id] ) return;
					s[id] = x.status;
					all.items[ id] = x;
					if ( x.delay > s.delay ) s.delay = x.delay;
					bys.push( { source: id, target: x.by } );
				});
				s.totFall = Object.keys(all.items).length;
				ns.stepSelected = s;
				ns.bys = bys;
				this.setState( ns, ()=>{
					this.tableSort(all);
				});
			})
		});
	}
	tableSort( data ) {
		if ( typeof data === 'undefined') data = this.state.stepData;
		if ( ! Array.isArray( data?.items ) ) data.items = Object.entries( data.items ).map( ([id,v])=> {
			v.id = id;
			return v;
		});
		const criteria = this.state.tableSort;
		const d = this.state.allItemsData;
		data.items.sort( ( a, b ) =>  (d[a.id].name.toLocaleLowerCase(this.state.ll).localeCompare(d[b.id].name.toLocaleLowerCase(this.state.ll))));
		switch (criteria.field ) {
			case "type": data.items.sort( ( a, b ) =>  (d[a.id].type.localeCompare(d[b.id].type))); break;
			case "subject": data.items.sort( ( a, b ) =>  ((d[d[a.id].subject||''].name||'').toLocaleLowerCase(this.state.ll).localeCompare((d[d[b.id].subject||''].name||'').toLocaleLowerCase(this.state.ll)))); break;
			case "delay": data.items.sort( ( a, b ) =>  ( (a.delay??0) - (b.delay??0))); break;
			case "c": data.items.sort( ( a, b ) =>  ( (a.status.c??0) - (b.status.c??0))); break;
			case "i": data.items.sort( ( a, b ) =>  ( (a.status.i??0) - (b.status.i??0))); break;
			case "a": data.items.sort( ( a, b ) =>  ( (a.status.a??0) - (b.status.a??0))); break;
			case "o": data.items.sort( ( a, b ) =>  ( (a.status.o??0) - (b.status.o??0))); break;
			default: break;
		}
		if (criteria.reverse) data.items.reverse();
		this.setState({ stepData: data, stepLoading: false });
	}
	sortBy( col ) {
		const s = this.state.tableSort;
		if ( s.field === col ) {
			s.reverse = ! s.reverse;
		} else {
			s.field = col;
			delete s.reverse;
		}
		this.setState({ tableSort: s }, this.tableSort);
	}
	showDelay( d ) {
		if ( ! d ) return '—';
		if ( d <= 90 ) return `${d}’`;
		if ( d < (36 * 60 )) return `${parseInt( d / 60)}:${String(parseInt(d % 60 )).padStart(2,'0')}’`;
		return `${parseInt( d / 1440)}d ${parseInt( (d % 1440) / 60)}:${String(parseInt(d % 60 )).padStart(2,'0')}’`;
	}
	render() {
		if ( ! this.state.stepSelected ) return (
			<div className={"p-3 limited"}>
				<br />
				<Progress animated={true} value={100} striped />
				<br />
			</div>
		);
		return(
			<>
				<div
					className={"panel-content "+prefix}
					style={{maxWidth:"min(100vw, 100%, 1600px)",margin:"0 auto"}}
				>
					<div className={"limited"}>
						<h3>
							<TextLabel value={"Simulation completed"} />
						</h3>
						<div className={"d-flex align-items-center"}>
							<Button
								color="primary"
								className={"btn-icon"}
								disabled={ this.state.stepLoading || this.state.currentStep === this.state.firstStep }
								onClick={ ()=>{ this.setState({currentStep: this.state.firstStep}, this.loadStep) }}
							>
								<i>
									<SkipToPreviousIcon />
								</i>
								<b>
									<TextLabel value={"Simulation started"} />
								</b>
							</Button>
							<Button
								color="primary"
								className={"btn-icon ms-2"}
								disabled={ this.state.stepLoading || this.state.currentStep === this.state.firstStep }
								onClick={ ()=>{
									const options = this.state.stepOptions;
									const curIndex = options.findIndex( x => x.value === this.state.currentStep );
									this.setState({currentStep: options[ curIndex -1].value }, this.loadStep)
								}}
							>
								<i>
									<ChevronLeftIcon />
								</i>
							</Button>
							<div className={"ps-2 pe-2 flex-grow-1"}>
								<MySelect
									isDisabled={ this.state.stepLoading }
									options={ this.state.stepOptions }
									value={ this.state.stepOptions.find( x => x.value === this.state.currentStep ) }
									onChange={ x => this.setState({currentStep: x?.value}, this.loadStep )}
								/>
							</div>
							<Button
								color="primary"
								className={"btn-icon me-2"}
								disabled={ this.state.stepLoading || this.state.currentStep === this.state.lastStep }
								onClick={ ()=>{
									const options = this.state.stepOptions;
									const curIndex = options.findIndex( x => x.value === this.state.currentStep );
									this.setState({currentStep: options[ curIndex +1].value }, this.loadStep)
								}}
							>
								<i>
									<ChevronRightIcon />
								</i>
							</Button>
							<Button
								color="primary"
								className={"btn-icon"}
								disabled={ this.state.stepLoading || this.state.currentStep === this.state.lastStep }
								onClick={ ()=>{ this.setState({currentStep: this.state.lastStep}, this.loadStep) }}
							>
								<b>
									<TextLabel value={"Simulation completed"} />
								</b>
								<i>
									<SkipToNextIcon />
								</i>
							</Button>
						</div>
					</div>
					{ (this.state.stepData) ? (
						<>
							<div className={"step-glance"}>
								<div className={"glance"}>
									<div className={"stage"}>
										<label><TextLabel value={"Stage"} /></label>
										<span>{ this.state.stepSelected.model || '—'}</span>
									</div>
									<div className={"delay"}>
										<label><TextLabel value={"Delay"} /></label>
										<span>{this.showDelay(this.state.stepSelected.delay)}</span>
									</div>
									<div className={"falling now"}>
										<label><TextLabel value={"Falling now"} /></label>
										<span>{ this.state.stepSelected.stepFall || '—'}</span>
									</div>
									<div className={"falling total"}>
										<label><TextLabel value={"Total falling"} /></label>
										<span>{ this.state.stepSelected.totFall || '—'}</span>
									</div>
									<div className={"elapsed"}>
										<label><TextLabel value={"Time elapsed"} /></label>
										<span>{ (String(this.state.stepSelected.elapsed / 1000)).replace(/\.(.).*$/,",$1")}”</span>
									</div>
								</div>
								<ButtonGroup
									className={"btn-icon"}
								>
									<Button
										color={"primary"}
										onClick={ () => {
											const simID = this.props.simul.id;
											const stepID = this.state.currentStep;
											appLib.api("simul/get-step", { simul: simID, step: stepID }).then( res =>{
												Glob.saveJSON( res, `simulation-${simID}-${stepID}.json` );
											})
										}}
									>
										<i>
											<AppDownloadIcon />
										</i>
										<b>
											<TextLabel value={"Download"} />
										</b>
									</Button>
									{ this.state.stepSelected?.model === 'operativo' && (
										<Button
											color={"success"}
											onClick={ ()=>{ this.setState({ useGraphic: true })} }
										>
											<b>
												<TextLabel value={"View"} />
											</b>
											<i>
												<AppPalleIcon />
											</i>
										</Button>
									)}
									{ this.state.stepSelected?.model === 'strategico' && (
										<Button
											color={"success"}
											onClick={ ()=>{ this.setState({ useGantt: true })} }
										>
											<b>
												<TextLabel value={"View"} />
											</b>
											<i>
												<ListIcon />
											</i>
										</Button>
									) }
								</ButtonGroup>
							</div>
							{ this.state.useGraphic && (
								<FullScreenModal
									title={ <>{ this.props.simul.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon /> } <span>{this.props.simul.info.name}</span></> }
									toggle={ ()=>{ this.setState({ useGraphic: false } ) }}
								>
									<PeriGraphic
										id={ this.props.simul.info.peri }
										selected={ this.state.stepSelected }
										subjects={ this.props.simul.limitToSubject }
										triggers={ this.state.triggers }
										bys={ this.state.bys }
										simul={ this.props.simul?.id }
										nav={{
											canPrevious: ()=> {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												if ( curIndex === 0 ) return false;
												const prevStep = options[ curIndex -1];
												return prevStep && !! prevStep?.operativo;
											},
											canNext: () => {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												const nextStep = options[ curIndex +1];
												return nextStep && !! nextStep?.operativo;
											},
											gotoPrevious: () => {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												this.setState({currentStep: options[ curIndex -1].value }, this.loadStep)
											},
											gotoNext: () => {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												this.setState({currentStep: options[ curIndex +1].value }, this.loadStep)
											},
										}}
									/>
								</FullScreenModal>
							)}
							{ this.state.useGantt && (
								<FullScreenModal
									title={ <>{ this.props.simul.fake ? <AppSynthDataIcon /> : <AppPerimeterIcon /> } <span>{this.state.stepSelected?.label }</span></> }
									toggle={ ()=>{ this.setState({ useGantt: false } ) }}
								>
									<PeriGantt 
										id={ this.props.simul.info.peri }
										stepData={ this.state.stepData }
										all={ this.state.allItemsData }
										nav={{
											canPrevious: ()=> {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												if ( curIndex === 0 ) return false;
												const prevStep = options[ curIndex -1];
												return prevStep && !! prevStep?.strategico;
											},
											canNext: () => {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												const nextStep = options[ curIndex +1];
												return nextStep && !! nextStep?.strategico;
											},
											gotoPrevious: () => {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												this.setState({currentStep: options[ curIndex -1].value }, this.loadStep)
											},
											gotoNext: () => {
												const options = this.state.stepOptions;
												const curIndex = options.findIndex( x => x.value === this.state.currentStep );
												this.setState({currentStep: options[ curIndex +1].value }, this.loadStep)
											},
										}}
									/>
								</FullScreenModal>
							)}
							<table className="table table-striped">
								<thead>
								<tr>
									<th
										className={ this.state.tableSort?.field === 'type' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive'}
										role={ "button" }
										onClick={ ()=>{ this.sortBy('type')}}
									>
										<TextLabel value={"Type"} />
									</th>
									<th
										className={ this.state.tableSort?.field === 'name' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive'}
										role={ "button" }
										onClick={ ()=>{ this.sortBy('name')}}
									>
										<TextLabel value={"Name"} />
									</th>
									{ this.state.model === 'strategico' ? (
										<th
											className={ this.state.tableSort?.field === 'delay' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive'}
											role={ "button" }
											onClick={ ()=>{ this.sortBy('delay')} }
										>
											<TextLabel value={"Delay"} />
										</th>
									) : (
										<th
											className={ this.state.tableSort?.field === 'subject' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive'}
											role={ "button" }
											onClick={ ()=>{ this.sortBy('subject')} }
										>
											<TextLabel value={"Subject"} />
										</th>
									)}
									<th
										className={ "text-center " + (this.state.tableSort?.field === 'c' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive')}
										role={ "button" }
										onClick={ ()=>{ this.sortBy('c')}}
									>C</th>
									<th
										className={ "text-center " + (this.state.tableSort?.field === 'i' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive')}
										role={ "button" }
										onClick={ ()=>{ this.sortBy('i')}}
									>I</th>
									<th
										role={ "button" }
										className={ "text-center " + (this.state.tableSort?.field === 'a' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive')}
										onClick={ ()=>{ this.sortBy('a')}}
									>A</th>
									<th
										role={ "button" }
										className={ "text-center " + (this.state.tableSort?.field === 'o' ? ('active'+( this.state.tableSort?.reverse ? ' reverse' : '')) : 'inactive')}
										onClick={ ()=>{ this.sortBy('o')}}
									>O</th>
								</tr>
								</thead>
								<tbody>
								{ this.state.stepData.items.map( v => (
									<tr key={v.id} className={ v.fresh ? 'fresh' : 'previous'}>
										<td>{ this.state.allItemsData[v.id].type }</td>
										<td>{ this.state.allItemsData[v.id].name }</td>
										{ this.state.model === 'strategico' ? (
											<td>{ this.showDelay(v.delay) }</td>
										) : (
											<td>{ this.state.allItemsData[v.id].subjectName }</td>
										)}
										<td className={"text-end"}>{ typeof v.status.c === 'number' ? String(Math.round( v.status.c * 100 ))+'%' : '—' }</td>
										<td className={"text-end"}>{ typeof v.status.i === 'number' ? String(Math.round( v.status.i * 100 ))+'%' : '—' }</td>
										<td className={"text-end"}>{ typeof v.status.a === 'number' ? String(Math.round( v.status.a * 100 ))+'%' : '—' }</td>
										<td className={"text-end"}>{ typeof v.status.o === 'number' ? String(Math.round( v.status.o * 100 ))+'%' : '—' }</td>
									</tr>
								))}
								</tbody>
							</table>
						</>
					) : (
						( !! this.state.stepLoading) && (
							<div className={"p-3 limited"}>
								<br />
								<Progress animated={true} value={100} striped />
								<br />
							</div>
						)
					)}
				</div>
				<div className={"panel-footer"}>
					<ButtonGroup className={"btn-icon"}>
						<Button
							color={"success"}
							onClick={()=>{ Glob.setCurrentPageParam('step','running') }}
						>
							<i>
								<ChevronLeftIcon />
							</i>
							<b>
								<TextLabel value={"Running"} />
							</b>
						</Button>
					</ButtonGroup>
					<ButtonGroup
						className={"btn-icon"}
					>
						<Button
							color={"success"}
							onClick={()=>Glob.gotoPage('Simulations')}
						>
							<b>
								<TextLabel value={"Available simulations"} />
							</b>
							<i>
								<ListIcon />
							</i>
						</Button>
					</ButtonGroup>
				</div>
			</>
		)
	}
}

export default SimulationFlowOver;